module.exports = __webpack_public_path__ + "be012527cf54a02f71bbd32f8c953249.pdf";